import { useState } from "react";
import { Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import RegionsViewAll from "../../features/mis/misGraphs/reginosVewAll";
import InnerLayout from "../../layout/innerLayout";
// import DepartmentList from "../../features/mis/misGraphs/departmentList";
// import TotalDiagonisis from "../../features/mis/misGraphs/totalDiagonisis";
import SpecialityList from "../../features/mis/misGraphs/specialityList";
import AllSourceNames from "../../features/mis/misGraphs/allSourceNames";
import MisGraphFilter from "../../features/mis/misGraphFilter";
import Breadcrumbs from "../../components/breadCrumbs";
import { addSpacesToCamelCase } from "../../helper";
import routesName from "../../constants/routesName";
import MADepartment from "../../features/mis/patientDetails/MADepartment";
import MADiagnosis from "../../features/mis/patientDetails/MADiagnosis";

const MisGraphs = () => {
  const location = useLocation();
  const label = location?.state && location?.state?.label;
  const isSingleHospital = location?.state?.singleHospital;
  const hospitalId = location?.state?.hospitalId;
  const [country, setCountry] = useState("");
  const [countryid, setCountryId] = useState("");
  const [state, setState] = useState("");
  const [stateid, setStateId] = useState("");
  const [district, setDistrict] = useState("");
  const [districtid, setDistrictId] = useState("");
  const [taluk, setTaluk] = useState("");
  const [talukid, setTalukId] = useState("");
  const [hobli, setHobli] = useState("");
  const [hobliid, setHobliId] = useState("");
  const [hospitalArray, setHospitalArray] = useState<any>([]);
  const [filterApplyToggle, setFilterApplyToggle] = useState(false);
  // console.log(hospitalId, "hospitalId")
  const renderComponent = () => {
    switch (label) {
      case "Regions":
        return (
          <RegionsViewAll
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            filterApplyToggle={filterApplyToggle}
          />
        );
      case "Departments":
        return (
          // <DepartmentList
          //   country={country}
          //   state={state}
          //   district={district}
          //   taluk={taluk}
          //   hobli={hobli}
          //   filterApplyToggle={filterApplyToggle}
          //   hospitalArray={hospitalArray}
          //   hospitalId={hospitalId}
          // />
          <MADepartment
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            hospitalArray={hospitalArray}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}
            countryid={countryid}
            stateid={stateid}
            districtid={districtid}
            talukid={talukid}
            hobliid={hobliid}
            all={true}
          />
        );
      case "Diagnosis":
        return (
          // <TotalDiagonisis
          //   country={country}
          //   state={state}
          //   district={district}
          //   taluk={taluk}
          //   hobli={hobli}
          //   filterApplyToggle={filterApplyToggle}
          //   hospitalArray={hospitalArray}
          //   hospitalId={hospitalId}

          // />
          <MADiagnosis
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            hospitalArray={hospitalArray}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}
            countryid={countryid}
            stateid={stateid}
            districtid={districtid}
            talukid={talukid}
            hobliid={hobliid}
            all={true}
          />
        );
      case "Speciality":
        return (
          <SpecialityList
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            filterApplyToggle={filterApplyToggle}
          />
        );
      case "OnboardingSource":
        return (
          <AllSourceNames
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            filterApplyToggle={filterApplyToggle}
          />
        );
      default:
        return null;
    }
  };

  const departmentsTableBreadcrumData = [
    {
      label: "MIS",
      navigate: `${routesName.managementInfoSystemPage}`,
      highLight: false,
    },

    {
      label: addSpacesToCamelCase(label),
      highLight: true,
    },
  ];

  return (
    <>
      <InnerLayout title="MIS">
        <div className="p-6">
          <Breadcrumbs data={departmentsTableBreadcrumData} />
        </div>
        <div className="px-6 ">
          <Grid container spacing={2}>
            {label !== "" && (
              <Grid item xs={12} sm={12} md={12}>
                <MisGraphFilter
                  country={country}
                  setCountry={setCountry}
                  setCountryId={setCountryId}
                  state={state}
                  setState={setState}
                  setStateId={setStateId}
                  district={district}
                  setDistrict={setDistrict}
                  setDistrictId={setDistrictId}
                  taluk={taluk}
                  setTaluk={setTaluk}
                  setTalukId={setTalukId}
                  hobli={hobli}
                  setHobli={setHobli}
                  setHobliId={setHobliId}
                  setFilterApplyToggle={setFilterApplyToggle}
                  label={label}
                  hospitalArray={hospitalArray}
                  setHospitalArray={setHospitalArray}
                  isSingleHospital={isSingleHospital}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={12} md={12}>
              {renderComponent()}
            </Grid>
          </Grid>
        </div>
      </InnerLayout>
    </>
  );
};
export default MisGraphs;
